<template>
  <v-card class="map">
    <div class="map_header">
      <span class="map_header-title"> カメラマップ </span>
      <v-btn icon class="map_header-action">
        <span class="icon icon-3dots" />
      </v-btn>
    </div>
    <div class="map_content">
      <v-img src="../../assets/img/map/map.png" height="211px" />
      <img
        class="map_content-camera"
        style="position: absolute; bottom: 42px; left: 80px"
        src="../../assets/img/map/camera.svg"
        alt="camera1"
      />
      <img
        class="map_content-camera"
        style="
          position: absolute;
          top: 37px;
          right: 146px;
          transform: rotate(235deg);
        "
        src="../../assets/img/map/camera.svg"
        alt="camera1"
      />
      <img
        class="map_content-camera"
        style="position: absolute; top: 118px; right: 26px"
        src="../../assets/img/map/fill-camera.svg"
        alt="camera1"
      />
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'MapA',
};
</script>

<style lang="scss">
.map {
  width: 395px;
  height: 331px;
  &_link {
    padding: 10px;
    margin-left: 20px;
    font-size: 13px;
    font-weight: normal;
    line-height: 18px;
    &-root {
      line-height: 1px;
    }
    .header & {
      color: #666;
    }
    &-active {
      text-decoration: none;
      background-color: #eeeeee;
      border-radius: 5px;
    }
    &.router-link-active {
      font-weight: 600;
      cursor: text;
      color: var(--primary-color);
      transform: scale(1.15);
      &:hover {
        text-decoration: none;
      }
    }
  }
  &_header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    &-title {
      color: #4b4b4b;
      font-size: 14px;
    }
    &-action {
      .icon {
        color: #989898;
        font-size: 14px;
      }
    }
  }
  &_content {
    position: relative;
    &-camera {
      position: absolute;
    }
  }
}
</style>
